import { dispatchTypes } from '../actions';
import { Reducer, AnyAction } from 'redux';

type EditBioState = {
  isLoading: boolean;
  apiResponse: Record<string, unknown>;
};

const initialState: EditBioState = {
  isLoading: false,
  apiResponse: {},
};

const editBioReducer: Reducer<EditBioState, AnyAction> = (
  state = initialState,
  action,
): EditBioState => {
  switch (action.type) {
    case dispatchTypes.EDITBIO.SAVE:
      return { ...state, isLoading: true };
    case dispatchTypes.EDITBIO.CLEARAPIRESPONSE:
      return { ...state, apiResponse: {} };
    case dispatchTypes.EDITBIO.SAVESUCCESS:
    case dispatchTypes.EDITBIO.SAVEERROR:
      return { ...state, isLoading: false, apiResponse: action.apiResponse || {} };
    default:
      return state;
  }
};

export default editBioReducer;
